import React from 'react'
import SlotCard from '../../../components/Slotcard/SlotCard'
// import DatanotFound from '../../components/DatanotFound/DatanotFound';
// --swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import moment from 'moment';
import Button from '../../../components/Button/Button';
import Skeleton from 'react-loading-skeleton';

function ViewSlots({ isActiveTab, isFetching, isSlotsFetching, selectedMonth, setAddSlotPopupToggler, selectedDate, setSelectedDate, slotDates, slots, monthNames, months, handleDateFilter, handleDeletePopup }) {

    const navigationNextRefNew = React.useRef(null);
    const navigationPrevRefNew = React.useRef(null);
    const navigationNextRefnext = React.useRef(null);
    const navigationNextRefpre = React.useRef(null);

    return (

        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>

            <div className="Headingforallheader">
                <div className="slottabbtn flex-between w-100">
                    <h2 className="heading-2">Slot Details</h2>
                    <Button name={'Add Slot'} src={'/assets/icons/AddIcon.svg'} className="BlueFillButton" onClick={() => setAddSlotPopupToggler(true)} />
                </div>
                
            </div>

            <div className="border-btm  w-100"> </div>

            {/* Body */}
            <div className="dateinputwrap flex">
                <h4 className='text3'>Pick a month</h4>
                <select className="dateDropdown" name='date' onChange={handleDateFilter} >
                {monthNames?.map((item, index) => (
                    <option className='menuList' key={index} value={months[index]} selected={selectedMonth === months[index]}>{monthNames[months[index]]}</option>
                ))}
                    </select>
                {/* <label htmlFor="date" className='Cudatedesign'>
                    <input type="date" id='date' />
                </label> */}
            </div>

            <div className="bodyDataForallUserdata">
                <div className="BodyViewSlotWrapper">
                    <div className="Bodymentordatawrap SwiperBodyWrappper MntSlotbook">
                        <div className="NextBtn swiperbtn" ref={navigationNextRefNew}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L9.53033 19.0303C9.23744 19.3232 8.76256 19.3232 8.46967 19.0303C8.17678 18.7374 8.17678 18.2626 8.46967 17.9697L13.9393 12.5L8.46967 7.03033C8.17678 6.73744 8.17678 6.26256 8.46967 5.96967Z" fill="black" />
                            </svg>
                        </div>
                        <Swiper
                            slidesPerView={2.3}
                            modules={[Navigation]}
                            loop={false}
                            spaceBetween={20}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                },
                                768: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    slidesPerView: 5,
                                },
                                1280: {
                                    slidesPerView: 7,
                                },

                            }}

                            onSwiper={(swiper) => {
                                // Delay execution for the refs to be defined
                                setTimeout(() => {
                                    // Override prevEl & nextEl now that refs are defined
                                    swiper.params.navigation.prevEl = navigationPrevRefNew.current
                                    swiper.params.navigation.nextEl = navigationNextRefNew.current

                                    // Re-init navigation
                                    swiper.navigation.destroy()
                                    swiper.navigation.init()
                                    swiper.navigation.update()
                                })
                            }}
                            navigation={{
                                // Both prevEl & nextEl are null at render so this does not work
                                prevEl: navigationPrevRefNew.current,
                                nextEl: navigationNextRefNew.current,
                            }}
                            onBeforeInit={(swiper) => {
                                swiper.navigation.nextEl = navigationNextRefNew.current;
                                swiper.navigation.prevEl = navigationPrevRefNew.current;
                            }}

                            className="mySwiper">

                            <div className='AdswiperWrappermain'>
                                {isFetching ?
                                <>
                                {[1,2,3,4].map(item => (
                                    <label className={`SlotCardWrapperBox`}>
                                    <input type="radio"/>
                                    <div className="SlotCardWrapper">
                                        <div className="bodySlotarea">
                                            <span className='Weekdays'>{<Skeleton width={"40px"} />}</span>
                                            <h4>{<Skeleton width={"50px"} />}</h4>
                                        </div>
                                        <div className={`FooterSlotCard`} >
                                        <Skeleton width={"70px"} />
                                        </div>
                                    </div>
                                </label>
                                ))}
                                </>
                             :
                                slotDates?.length > 0 ? slotDates?.map((item , index) => (
                                 <SwiperSlide >
                                    <SlotCard key={index} name={'one'} id={'slot'+index} day={item?.slotsDate ? moment(item?.slotsDate).format("ddd") : "---"} date={item?.slotsDate ? moment(item?.slotsDate).format("DD MMM") : "---"} checked={selectedDate === item?.slotsDate} onChange={() => setSelectedDate(item?.slotsDate)} slotsCount={item?.slotsCount}/>
                                </SwiperSlide> 
                                )) : <div className='flex-center w-100'><DatanotFound /></div>}

                            </div>
                        </Swiper>

                        <div className="PreBtn swiperbtn" ref={navigationPrevRefNew}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M15.5303 5.96967C15.8232 6.26256 15.8232 6.73744 15.5303 7.03033L10.0607 12.5L15.5303 17.9697C15.8232 18.2626 15.8232 18.7374 15.5303 19.0303C15.2374 19.3232 14.7626 19.3232 14.4697 19.0303L8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697L14.4697 5.96967C14.7626 5.67678 15.2374 5.67678 15.5303 5.96967Z" fill="black" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div className="Dashborder"></div>

                {slots?.length > 0 && <div className="SlotAreaWrapperallCard SwiperBodyWrappper">
                    <div className="NextBtn swiperbtn" ref={navigationNextRefnext}>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L9.53033 19.0303C9.23744 19.3232 8.76256 19.3232 8.46967 19.0303C8.17678 18.7374 8.17678 18.2626 8.46967 17.9697L13.9393 12.5L8.46967 7.03033C8.17678 6.73744 8.17678 6.26256 8.46967 5.96967Z" fill="black" />
                        </svg>
                    </div>
                    <Swiper
                        slidesPerView={1.9}
                        modules={[Navigation]}
                        loop={false}
                        spaceBetween={20}
                        breakpoints={{
                            640: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 3,
                            },
                            1024: {
                                slidesPerView: 4,
                            },
                            1280: {
                                slidesPerView: 6,
                            },

                        }}

                        onSwiper={(swiper) => {
                            // Delay execution for the refs to be defined
                            setTimeout(() => {
                                // Override prevEl & nextEl now that refs are defined
                                swiper.params.navigation.prevEl = navigationNextRefnext.current
                                swiper.params.navigation.nextEl = navigationNextRefpre.current

                                // Re-init navigation
                                swiper.navigation.destroy()
                                swiper.navigation.init()
                                swiper.navigation.update()
                            })
                        }}
                        navigation={{
                            // Both prevEl & nextEl are null at render so this does not work
                            prevEl: navigationNextRefnext.current,
                            nextEl: navigationNextRefpre.current,
                        }}
                        onBeforeInit={(swiper) => {
                            swiper.navigation.nextEl = navigationNextRefnext.current;
                            swiper.navigation.prevEl = navigationNextRefpre.current;
                        }}

                        className="mySwiper">

                        <div className='SlotAreaWrapperallCard'>
                                {isSlotsFetching ?
                                <>
                                {[1,2,3,4].map(item => (
                                    <label lassName="TimeSlotsCrad" >
                                    {/* <input type="radio"/> */}
                                    <div className='mainSlotBox'>
                                        <Skeleton width={"70px"} />
                                    </div>
                                    {/* <div className="hoverDelete" onClick={() => handleDeletePopup(item?.id)}>
                                        <img src="../assets/svg/trashWhite.svg" alt="" />
                                        Remove
                                    </div> */}
                                </label>
                                ))}
                                </>
                            : slots?.length > 0 ? slots?.map((item, index) => (
                            <SwiperSlide>
                                <label key={index} className="TimeSlotsCrad" htmlFor={'one' + index} >
                                    <input type="radio" name={'name'} id={'one' + index} disabled />
                                    <div className='mainSlotBox'>
                                        {item?.startTime ? moment(item?.startTime).utcOffset("-00:00").format("hh:mm a") : "---"}
                                    </div>
                                    <div className="hoverDelete" onClick={() => handleDeletePopup(item?.id)}>
                                        <img src="../assets/svg/trashWhite.svg" alt="" />
                                        Remove
                                    </div>
                                </label>
                            </SwiperSlide>
                                )) : "Please select date"}

                        </div>
                    </Swiper>
                    <div className="PreBtn swiperbtn" ref={navigationNextRefpre}>
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M15.5303 5.96967C15.8232 6.26256 15.8232 6.73744 15.5303 7.03033L10.0607 12.5L15.5303 17.9697C15.8232 18.2626 15.8232 18.7374 15.5303 19.0303C15.2374 19.3232 14.7626 19.3232 14.4697 19.0303L8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697L14.4697 5.96967C14.7626 5.67678 15.2374 5.67678 15.5303 5.96967Z" fill="black" />
                        </svg>
                    </div>
                </div>}
            </div>

        </div>

    )
}

export default ViewSlots